exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-theme*=dark] .lm-FieldGroupMessages{color-scheme:dark;--lm-FieldGroupMesssages-font-color: #f25a5a}.lm-FieldGroupMessages{font-family:Roboto,Arial,sans-serif;-webkit-box-sizing:border-box;box-sizing:border-box;--lm-FieldGroupMesssages-font-color: #D32F2F;width:100%;margin-bottom:.5rem}.lm-FieldGroupMessages *{-webkit-box-sizing:inherit;box-sizing:inherit}.lm-FieldGroup-label+.lm-FieldGroupMessages.has-messages{margin-top:-1.5rem}ul.lm-FieldGroupMessage{margin:0 0 .25rem 0;padding:0}ul.lm-FieldGroupMessage:last-child{margin:0}ul.lm-FieldGroupMessage li{list-style:none;font-size:.75rem;line-height:1.2;font-weight:400;padding:2px 0 2px 24px;position:relative}ul.lm-FieldGroupMessage li+li{margin-top:.25rem}ul.lm-FieldGroupMessage li .lm-Icon{position:absolute;left:0;top:0}ul.lm-FieldGroupMessage.is-error li{color:var(--lm-FieldGroupMesssages-font-color)}@media all and (-ms-high-contrast: active){ul.lm-FieldGroupMessage.is-error li{color:highlight}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"includePaths":["./node_modules"]}!./node_modules/@lmig/lmds-react-field-group/dist/_esm/fieldGroupMessages.css
// module id = 2708
// module chunks = 0